import { EventObject } from "../../events/EventObject.js";

/**
 * Binder for a DASF (Data Analytics Software Framework) backend module 
 * @memberof vef.data.dasf
 */
export class DASFBinder extends EventObject { }